import React, {useRef, useState} from 'react';
import "./AbroadApplicationForm.css"
import {Button, Collapse, Form, Input, Tabs} from "antd";
import {FormItem} from "./FormItem";
import {FormCard} from "./FormCard";

const {TabPane} = Tabs;
const {Panel} = Collapse;
const FormOptions = {
    country: [
        {
            value: 'USA',
            label: 'USA'
        },
        {
            value: 'UK',
            label: 'UK'
        },
        {
            value: 'Germany',
            label: 'Germany'
        },
        {
            value: 'Canada',
            label: 'Canada'
        },
        {
            value: 'New Zealand',
            label: 'New Zealand'
        },
        {
            value: 'Australia',
            label: 'Australia'
        },
    ],
}
const FormTabData = [
    {
        label: "Personal Information",
    },
    {
        label: "Academic Qualification",
    },
    {
        label: "Work Experience",
    },
    {
        label: "Tests",
    },
]

const Options = ({optionsData}) => {
    return optionsData.map(option => {
        return <option key={option.value} value={option.value}>{option.label}</option>
    })
}

const statusLabel = ["Incomplete", "Complete", "Optional"]
const statusColor = ["red", "Green"]

const Tab = ({setFormStage, activeTab, tabLabel, count}) => {
    const defaultTabStyle = ["d-flex flex-column align-items-center px-5 py-2"]

    return (
        <div
            onClick={() => setFormStage(count + 1)}
            className=
                {
                    [
                        defaultTabStyle,
                        activeTab === count + 1
                            ? "text-white"
                            : "bg-light"
                    ].join(" ")
                }>
            <span className={"h4"}>{tabLabel}</span>
            <span
                className={"h6 font-weight-bold"}
                style={{color: statusColor[0]}}
            >
                {count === 2 ? statusLabel[2] : statusLabel[0]}
            </span>
        </div>
    )
}

const ExamsList = ["GRE", "GMAT", "TOEFL", "IELTS", "PTE", "DET", "SAT", "ACT",]

const AbroadApplicationForm = () => {
    const [activeTab, setActiveTab] = useState(1)       // holds activeTab key for selected tab style
    const [activeKey, setActiveKey] = useState(0)

    const [formStage, setFormStage] = useState(activeTab)
    const [loading, setLoading] = useState(false)
    const formRef = useRef(null)

    const onFinish = () => {
        setLoading(true)
        formRef.current.validateFields()
            .then(formData => {
                    // fetch(captureLeads_URL, {
                    //     method: 'POST',
                    //     headers: {
                    //         'Accept': 'application/json',
                    //         'Content-Type': 'application/json',
                    //     },
                    //     body: JSON.stringify({
                    //         'emails': [
                    //             'abroad.admissions@careerdose.com',
                    //         ],
                    //         'subject': 'Admissions Abroad lead notification',
                    //         'body': {
                    //             "first_name": formData["first_name"],
                    //             "email1": formData["email1"],
                    //             "phone_mobile": formData["phone_mobile"],
                    //             "description": `Country: ${formData["description_country"]} \n Start Year: ${formData["description_start_year"]} \nDegree: ${formData["description_degree"]} \nSubject: ${formData["description_subject"]}`
                    //         },
                    //         'type': 'abroad_web'
                    //     })
                    // }).then((resp) => {
                    // })
                    // history.push({
                    //     pathname: '/inquiry-received',
                    //     state: {
                    //         type: 'abroad'
                    //     },
                    // });
                    console.log(formData)
                }
            )
            .catch(() => {
                setLoading(false)
            })
    };
    // useEffect(() => {
    //     window.addEventListener('beforeunload', function (e) {
    //         e.preventDefault();
    //         e.returnValue = '';
    //     });
    //     window.addEventListener('onbeforeunload ', function (e) {
    //         e.preventDefault();
    //         e.returnValue = '';
    //     });
    // })           // to alert on unsaved changes
    return (
        <section>
            <div className="banner-2 cd-danger-gradient">
                <p className="display-4 font-weight-bold text-white text-nowrap">
                    Doing the Right Thing The Right Way
                </p>
            </div>
            <Tabs
                centered
                defaultActiveKey={1}
                animated={{inkBar: false, tabPane: true}}
                tabBarGutter={0}
                onTabClick={(key, e) => {
                    setActiveTab(parseInt(key))
                }}
            >{
                FormTabData.map((formTab, count) => {
                    return (
                        <TabPane
                            tab={<Tab
                                setFormStage={setFormStage}
                                activeTab={activeTab}
                                tabLabel={formTab.label}
                                count={count}
                            />}
                            key={count + 1}
                        >
                            {formStage === 1 && <>
                                <Form.Provider>
                                    <FormCard
                                        formName={"personal-info"}
                                        headerLabel={"Personal Information"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Name"}
                                                        formItemName={"abroad-appForm-personal-info--name"}
                                                        required={true}
                                                        inputType={"text"}
                                                        placeholder={"Full Name"}
                                                    />
                                                    <FormItem
                                                        label={"Email"}
                                                        formItemName={"abroad-appForm-personal-info--email"}
                                                        rules={[{
                                                            type: 'email',
                                                            message: 'The is not a valid E-mail!',
                                                        }, {
                                                            required: true,
                                                            message: 'Please enter vaild E-mail!',
                                                        },]}
                                                        inputType={"email"}
                                                        placeholder={"Enter Email"}
                                                    />
                                                    <FormItem
                                                        label={"Contact Number"}
                                                        formItemName={"abroad-appForm-personal-info--contact-number"}
                                                        rules={[{
                                                            validator: (_, value) => ("+91" + value.replace("+91", "")).toString().length === 13 ? Promise.resolve() : Promise.reject(new Error('Please input your phone number!'))
                                                        },]}
                                                        required={true}
                                                        inputType={"tel"}
                                                    />
                                                </div>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Date of Birth"}
                                                        formItemName={"abroad-appForm-personal-info--DOB"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                    <FormItem
                                                        label={"Gender"}
                                                        formItemName={"abroad-appForm-personal-info--Gender"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </FormItem>
                                                    <FormItem
                                                        label={"Marital Status"}
                                                        formItemName={"abroad-appForm-personal-info--marital-status"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Marital Status
                                                            </option>
                                                            <option value="married">Married</option>
                                                            <option value="unmarried">Unmarried</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </FormItem>

                                                </div>
                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"mailing-address"}
                                        headerLabel={"Mailing Address"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Address 1"}
                                                        formItemName={"abroad-appForm-mailing-address--address-1"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <FormItem
                                                        label={"Address 2"}
                                                        formItemName={"abroad-appForm-mailing-address--address-2"}
                                                        inputType={"text"}
                                                    />
                                                </div>

                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Country"}
                                                        formItemName={"abroad-appForm-mailing-address--country"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                    <FormItem
                                                        label={"State"}
                                                        formItemName={"abroad-appForm-mailing-address--state"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select State</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                </div>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"City"}
                                                        formItemName={"abroad-appForm-mailing-address--city"}
                                                        inputType={"text"}
                                                        required={true}
                                                    />
                                                    <FormItem
                                                        label={"Pincode"}
                                                        formItemName={"abroad-appForm-mailing-address--pincode"}
                                                        inputType={"number"}
                                                        required={true}
                                                    />
                                                </div>

                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"permanent-address"}
                                        headerLabel={"Permanent Address"}
                                        customHeader={
                                            <div
                                                className={"d-flex flex-row align-items-center justify-content-between"}>
                                                        <span className="h3">
                                                        Permanent Address
                                                        </span>

                                                <span
                                                    className="d-flex flex-row align-items-center h5"
                                                    style={{"white-space": "nowrap"}}>
                                                                <input type={"checkbox"}
                                                                       style={{
                                                                           accentColor: '#4285f4',
                                                                           marginRight: '3%'
                                                                       }}
                                                                />
                                                                <span>Same as mailing address</span>
                                                        </span>
                                            </div>
                                        }
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Address 1"}
                                                        formItemName={"abroad-appForm-permanent-address--address-1"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <FormItem
                                                        label={"Address 2"}
                                                        formItemName={"abroad-appForm-permanent-address--address-2"}
                                                        inputType={"text"}
                                                    />
                                                </div>

                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Country"}
                                                        formItemName={"abroad-appForm-permanent-address--country"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                    <FormItem
                                                        label={"State"}
                                                        formItemName={"abroad-appForm-permanent-address--state"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select State</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                </div>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"City"}
                                                        formItemName={"abroad-appForm-permanent-address--city"}
                                                        inputType={"text"}
                                                        required={true}
                                                    />
                                                    <FormItem
                                                        label={"Pincode"}
                                                        formItemName={"abroad-appForm-permanent-address--pincode"}
                                                        inputType={"number"}
                                                        required={true}
                                                    />
                                                </div>

                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"passport-information"}
                                        headerLabel={"Passport Information"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Passport Number"}
                                                        formItemName={"abroad-appForm-passport-information--passport-number"}
                                                        required={true}
                                                        inputType={"number"}
                                                    />
                                                    <FormItem
                                                        label={"Issue Date"}
                                                        formItemName={"abroad-appForm-passport-information--issue-date"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                    <FormItem
                                                        label={"Expiry Date"}
                                                        formItemName={"abroad-appForm-passport-information--expiry-date"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                </div>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Issue Country"}
                                                        formItemName={"abroad-appForm-passport-information--issue-country"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"City of Birth"}
                                                        formItemName={"abroad-appForm-passport-information--city-of-birth"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                    <FormItem
                                                        label={"Country of Birth"}
                                                        formItemName={"abroad-appForm-passport-information--country-of-birth"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />

                                                </div>
                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"nationality"}
                                        headerLabel={"Nationality"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Nationality"}
                                                        formItemName={"abroad-appForm-nationality--nationality"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                    <FormItem
                                                        label={"Nationality"}
                                                        formItemName={"abroad-appForm-nationality--nationality"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                </div>

                                                <div className={"row"}>

                                                    <FormItem
                                                        label={"Is the applicant a citizen of more than one country?"}
                                                        formItemName={"abroad-appForm-nationality--nationality-more"}
                                                        required={true}
                                                        inputType={"select"}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Is the applicant living and studying in any other country?"}
                                                        formItemName={"abroad-appForm-nationality--nationality"}
                                                        required={true}
                                                        inputType={"select"}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Living Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                </div>

                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100 mt-2"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"background-info"}
                                        headerLabel={"Background Info"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>

                                                    <FormItem
                                                        label={"Has applicant applied for any type of immigration into any country??"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Does applicant suffer from a serious medical condition??"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <Input type={"text"} placeholder={"Specify Here..."}/>
                                                    </FormItem>

                                                </div>
                                                <div className={"row"}>

                                                    <FormItem
                                                        label={"Has applicant Visa refusal for any country?"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Living Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                        <br/><br/>
                                                        <Input type={"text"} placeholder={"Type of Visa"}/>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Has applicant ever been convicted of a criminal offence?"}
                                                        formItemName={"abroad-appForm-nationality--nationality"}
                                                        required={true}
                                                        inputType={"select"}
                                                        addButton={true}
                                                    >
                                                        <Input type={"text"} placeholder={"Specify Here..."}/>
                                                    </FormItem>
                                                </div>
                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100 mt-2"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"emergency-contacts"}
                                        headerLabel={"Emergency Contacts"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>

                                                    <FormItem
                                                        label={"Has applicant applied for any type of immigration into any country??"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Does applicant suffer from a serious medical condition??"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <Input type={"text"} placeholder={"Specify Here..."}/>
                                                    </FormItem>

                                                </div>
                                                <div className={"row"}>

                                                    <FormItem
                                                        label={"Has applicant Visa refusal for any country?"}
                                                        formItemName={"abroad-appForm-background-info--[Has applicant applied for any type of immigration into any country?]"}
                                                        required={true}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Living Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                        <br/><br/>
                                                        <Input type={"text"} placeholder={"Type of Visa"}/>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Is the applicant living and studying in any other country?"}
                                                        formItemName={"abroad-appForm-nationality--nationality"}
                                                        required={true}
                                                        inputType={"select"}
                                                        addButton={true}
                                                    >
                                                        <select>
                                                            <option value="">Select Living Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>
                                                </div>
                                                <Form.Item className="mb-0">
                                                    <Button
                                                        className="btn text-white bg-success font-weight-bold h-100 mt-2"
                                                        type="submit" htmltype="submit"
                                                        onClick={() => onFinish()}
                                                        loading={loading}
                                                    >
                                                        Save
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        }
                                    />
                                </Form.Provider>
                            </>}
                            {formStage === 2 && <>
                                <Form.Provider>
                                    <FormCard
                                        formName={"education-summary"}
                                        headerLabel={"Education Summary"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Country of Education"}
                                                        formItemName={"abroad-appForm-personal-info--DOB"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Country</option>
                                                            <Options
                                                                optionsData={FormOptions['country']}/>
                                                        </select>
                                                    </FormItem>

                                                    <FormItem
                                                        label={"Highest Level of Education*"}
                                                        formItemName={"abroad-appForm-personal-info--Gender"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select level</option>
                                                            <option value="Post Graduate">Post Graduate</option>
                                                            <option value="Graduate">Graduate</option>
                                                            <option value="Grade 12th or Higher equivalent">Grade
                                                                12th or Higher equivalent
                                                            </option>
                                                        </select>
                                                    </FormItem>

                                                </div>
                                            </>
                                        }
                                    />
                                    <FormCard
                                        formName={"grade-12th-or-equivalent"}
                                        headerLabel={"Grade 12th or equivalent"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Level of Study"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--level-of-study"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Select Level</option>
                                                            <option value="1">Foundation</option>
                                                            <option value="2">Grade 9th</option>
                                                            <option value="">Grade 10th or equivalent</option>
                                                            <option value="4">Grade 11th</option>
                                                            <option value="">Grade 12th or equivalent</option>
                                                            <option value="6">UG Diploma/Certificate/Associate
                                                                Degree
                                                            </option>
                                                            <option value="9">PG Diploma/Certificate</option>
                                                            <option value="11">PhD</option>
                                                            <option value="12">Other</option>
                                                        </select>

                                                    </FormItem>

                                                    <FormItem
                                                        label={"Name of Board"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--name-of-board"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <FormItem
                                                        label={"Name of Institution"}
                                                        formItemName={"abroad-appForm-personal-name-of-institution"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <div className="col">
                                                        <div className="row">
                                                            <FormItem
                                                                label={"Country of Study"}
                                                                formItemName={"abroad-appForm-grade-12th-or-equivalent--country-of-study"}
                                                                required={true}
                                                                inputType={"select"}
                                                            >
                                                                <select>
                                                                    <option value="">Select Country</option>
                                                                    <Options
                                                                        optionsData={FormOptions['country']}/>
                                                                </select>
                                                            </FormItem>
                                                            <FormItem
                                                                label={"State of Study"}
                                                                formItemName={"abroad-appForm-grade-12th-or-equivalent--state-of-study"}
                                                                required={true}
                                                                inputType={"select"}
                                                            >
                                                                <select>
                                                                    <option value="">Select State</option>
                                                                    <Options
                                                                        optionsData={FormOptions['country']}/>
                                                                </select>
                                                            </FormItem>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <FormItem
                                                        label={"City of Study"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--city-of-study"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <FormItem
                                                        label={"Qualification Achieved/Degree Awarded"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--Qualification-Achieved-/-Degree-Awarded"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col">
                                                        <div className="row">
                                                                <span className={"col-sm-3"}>
                                                                    <FormItem
                                                                        label={"Grading System"}
                                                                        formItemName={"abroad-appForm-personal-grading-system"}
                                                                        required={true}
                                                                        inputType={"select"}
                                                                    >
                                                                    <select>
                                                                        <option value="">Select...</option>
                                                                        <option value="100">100</option>
                                                                        <option value="45">45</option>
                                                                        <option value="10">10</option>
                                                                        <option value="7">7</option>
                                                                        <option value="5">5</option>
                                                                        <option value="4">4</option>
                                                                    </select>
                                                                </FormItem>
                                                                </span>
                                                            <span className={"col"}>
                                                                    <FormItem
                                                                        label={"Score(12th)"}
                                                                        formItemName={"abroad-appForm-personal-city-of-study"}
                                                                        required={true}
                                                                        inputType={"text"}
                                                                    />
                                                                </span>
                                                        </div>
                                                    </div>
                                                    <FormItem
                                                        label={"Primary Language of Instruction"}
                                                        formItemName={"abroad-appForm-personal-primary-language-of-instruction"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <FormItem
                                                        label={"Start Date"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--start-date"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                    <FormItem
                                                        label={"End Date"}
                                                        formItemName={"abroad-appForm-grade-12th-or-equivalent--end-date"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                </div>
                                            </>
                                        }
                                    />
                                    <div className={"text-center"}>
                                        <Form.Item className="mb-0">
                                            <Button
                                                icon={<span className={"px-2 h5"}>+</span>}
                                                type={"primary"}
                                                size={"large"}
                                                className="flex-grow-1 px-2"
                                                htmltype="submit"
                                                onClick={() => onFinish()}
                                                loading={loading}
                                            >
                                                Add Another
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Form.Provider>
                            </>}
                            {formStage === 3 && <>
                                <Form.Provider>
                                    <FormCard
                                        formName={"education-summary"}
                                        headerLabel={"Education Summary"}
                                        FormBody={
                                            <>
                                                <div className={"row"}>
                                                    <FormItem
                                                        label={"Name of the Organisation & Address"}
                                                        formItemName={"abroad-appForm-education-summary--name-of-organisation-and-address"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <FormItem
                                                        label={"Position"}
                                                        formItemName={"abroad-appForm-education-summary--position"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                </div>
                                                <div className="row">
                                                    <FormItem
                                                        label={"Job Profile"}
                                                        formItemName={"abroad-appForm-education-summary--job-profile"}
                                                        required={true}
                                                        inputType={"text"}
                                                    />
                                                    <FormItem
                                                        label={"Mode of Salary"}
                                                        formItemName={"abroad-appForm-education-summary--mode-of-salary"}
                                                        required={true}
                                                        inputType={"select"}
                                                    >
                                                        <select>
                                                            <option value="">Mode of Salary</option>
                                                            <option value="Cash">Cash</option>
                                                            <option value="Cheque">Cheque</option>
                                                            <option value="Bank Transfer">Bank Transfer</option>
                                                        </select>
                                                    </FormItem>
                                                </div>
                                                <div className="row">
                                                    <FormItem
                                                        label={"Working From"}
                                                        formItemName={"abroad-appForm-education-summary--working-from"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                    <FormItem
                                                        className={"col-2"}
                                                        label={"I am currently working here"}
                                                        formItemName={"abroad-appForm-education-summary--currently-working-status"}
                                                        required={true}
                                                        addButton={true}
                                                        invertSwitch={true}
                                                    />
                                                    <FormItem
                                                        label={"Working From"}
                                                        formItemName={"abroad-appForm-education-summary--working-upto"}
                                                        required={true}
                                                        inputType={"date"}
                                                    />
                                                </div>
                                            </>
                                        }
                                    />
                                    <div className={"text-center"}>
                                        <Form.Item className="mb-0">
                                            <Button
                                                icon={<span className={"px-2 h5"}>+</span>}
                                                type={"primary"}
                                                size={"large"}
                                                className="flex-grow-1 px-2"
                                                htmltype="submit"
                                                onClick={() => onFinish()}
                                                loading={loading}
                                            >
                                                Add Another
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Form.Provider>
                            </>}
                            {formStage === 4 && <>
                                <Form.Provider>
                                    {ExamsList.map((exam,index) => {
                                        return (
                                            <div className="ant-collapse-wrapper cd-container-2">
                                                <Collapse
                                                    expandIconPosition={"end"}
                                                >
                                                    <Panel
                                                        header={<span className={"h5 font-weight-bold"}>
                                                            {exam}
                                                        </span>}
                                                        key={index}>
                                                        <FormCard
                                                            className={"text-nowrap"}
                                                            formName={"exam-gre"}
                                                            headerLabel={"Education Summary"}
                                                            FormBody={
                                                                <>
                                                                    <div className={"row"}>
                                                                        <FormItem
                                                                            label={"Name of the Organisation & Address"}
                                                                            formItemName={"abroad-appForm-education-summary--name-of-organisation-and-address"}
                                                                            required={true}
                                                                            inputType={"text"}
                                                                        />
                                                                        <FormItem
                                                                            label={"Position"}
                                                                            formItemName={"abroad-appForm-education-summary--position"}
                                                                            required={true}
                                                                            inputType={"text"}
                                                                        />
                                                                    </div>
                                                                    <div className="row">
                                                                        <FormItem
                                                                            label={"Job Profile"}
                                                                            formItemName={"abroad-appForm-education-summary--job-profile"}
                                                                            required={true}
                                                                            inputType={"text"}
                                                                        />
                                                                        <FormItem
                                                                            label={"Mode of Salary"}
                                                                            formItemName={"abroad-appForm-education-summary--mode-of-salary"}
                                                                            required={true}
                                                                            inputType={"select"}
                                                                        >
                                                                            <select>
                                                                                <option value="">Mode of Salary</option>
                                                                                <option value="Cash">Cash</option>
                                                                                <option value="Cheque">Cheque</option>
                                                                                <option value="Bank Transfer">Bank
                                                                                    Transfer
                                                                                </option>
                                                                            </select>
                                                                        </FormItem>
                                                                    </div>
                                                                </>
                                                            }
                                                        />
                                                    </Panel>
                                                </Collapse>
                                            </div>
                                        )
                                    })}

                                </Form.Provider>
                            </>}
                        </TabPane>
                    )
                })
            }
            </Tabs>
        </section>
    );
};

export default AbroadApplicationForm;